/**
 * Публичный URL после успешной отправки формы регистрации на `/auth`.
 * Используется для целей конверсии в VK Ads / Top.Mail.Ru (уникальный путь, не совпадает с обычным профилем).
 */
export const AUTH_SIGNUP_SUCCESS_PATH = "/auth/signup-success";
